import { DefaultButton } from 'common/presentation/components';
import TextField from 'common/presentation/components/text-field/TextField';
import {
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormHelperText,
	InputLabel,
} from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
	open: boolean;
	handleCancel: () => void;
	handleConfirm: (code: string) => void;
	error: string
	loading: boolean
}

const TwoFactorDialog: FC<Props> = (props) => {
	const {
		open, handleCancel, handleConfirm, error, loading,
	} = props;
	const { t } = useTranslation('translations');

	const [code, setCode] = useState('');

	const handleConfirmClick = () => {
		handleConfirm(code);
	};

	return (
		<Dialog
			open={open}
			onClose={handleCancel}
		>
			<DialogTitle>{t('two_factor_auth_status')}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{t('enter_generated_code')}
				</DialogContentText>
				<div>
					<InputLabel shrink htmlFor="bootstrap-input">
						{t('code')}
					</InputLabel>
					<TextField
						fullWidth
						type="number"
						placeholder="code"
						value={code}
						inputProps={{ maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }}
						onChange={(e) => {
							const val = e.target.value;
							if (/^\d*$/.test(val) && val.length <= 6) {
								setCode(val);
							}
						}}
					/>
				</div>
				{error && (
					<FormHelperText>
						{error}
					</FormHelperText>
				)}
			</DialogContent>
			<DialogActions>
				<DefaultButton disabled={loading} color="error" onClick={handleCancel}>{t('cancel')}</DefaultButton>
				<DefaultButton disabled={loading} onClick={handleConfirmClick}>
					{!loading && t('confirm')}
					{loading && <CircularProgress size={28} />}
				</DefaultButton>
			</DialogActions>
		</Dialog>
	);
};

export default TwoFactorDialog;
